import React, {useEffect, useState} from "react";
import {getUserCertificates} from "../../service";
import {getUserStorage} from "../../units";
import logo from '../../images/logo-gold.png'
import line from '../../images/zsline.png'
import Pagination from "../../components/pagination";
import usePagination from "../../routers/usePagination";
import {Certificates} from "../types";

const names = ['一星证书', '二星证书', '三星证书']

function Certificate() {
    const useData = getUserStorage()
    const [pageNum, setPage] = useState(1)
    const [lists, setLists] = useState<Array<Certificates>>([])
    const { pageRef,noMore,reset } = usePagination();


    useEffect(() => {
        if (useData) {
            getUserCertificates({
                userId: useData.id,
                pageNum
            }).then(res => {
                const lists = res.data.list
                if((lists as Array<Certificates>).length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            })
        }

    }, [pageNum])

    return <div className="certificate">
        <img src={logo} alt="" className='_logo'/>
        <div className="lists" style={{ paddingBottom:'.3rem' }}>
            {
                lists.map((item, index) => {
                    return <div className="item" key={index}>
                        {
                            index > 0 && <img src={line} className='line' alt=""/>
                        }
                        {/*<Stars count={index + 1}/>*/}
                        <h3>{ item.certificateNumber }</h3>
                        <img src={ item.downloadUrl } className='zs' alt=""/>
                    </div>
                })
            }
        </div>
        <Pagination ref={pageRef} length={lists.length}  onChange={ (n) => setPage(n) }/>
    </div>
}

export default Certificate;
